import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { Checkbox } from "../Checkbox";

import styles from "./LegalConsent.scss";

import LegalConsentHeading from "./LegalConsentHeading";
import LegalConsentText from "./LegalConsentText";

export const LegalConsent = forwardRef(
  (
    {
      hideCheckbox,
      customClass,
      children,

      // checkbox pass-through props
      value,
      isValid,
      disabled,
      checked,
      onChange,
      ...otherProps
    },
    ref
  ) => {
    let innerElements = children;
    const classNames = [customClass];

    if (!hideCheckbox) {
      const childrenArray = React.Children.toArray(children);
      const Heading = childrenArray.find(
        (child) => child.type === LegalConsentHeading
      );
      const Text = childrenArray.find(
        (child) => child.type === LegalConsentText
      );

      innerElements = (
        <>
          {Heading}
          <Checkbox
            value={value}
            isValid={isValid}
            disabled={disabled}
            checked={checked}
            onChange={onChange}
          >
            {Text}
          </Checkbox>
        </>
      );
    } else {
      classNames.push(styles["without-checkbox"]);
    }

    return (
      <div ref={ref} className={cx(classNames)} {...otherProps}>
        {innerElements}
      </div>
    );
  }
);

LegalConsent.defaultProps = {
  hideCheckbox: false,
  customClass: null,

  // checkbox pass-through props
  value: Checkbox.defaultProps.value,
  isValid: Checkbox.defaultProps.isValid,
  disabled: Checkbox.defaultProps.disabled,
  checked: Checkbox.defaultProps.checked,
  onChange: Checkbox.defaultProps.onChange,
};

LegalConsent.propTypes = {
  hideCheckbox: PropTypes.bool,
  customClass: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,

  // checkbox pass-through props
  value: Checkbox.propTypes.value,
  isValid: Checkbox.propTypes.isValid,
  disabled: Checkbox.propTypes.disabled,
  checked: Checkbox.propTypes.checked,
  onChange: Checkbox.propTypes.onChange,
};

LegalConsent.Heading = LegalConsentHeading;
LegalConsent.Text = LegalConsentText;

LegalConsent.displayName = "LegalConsent";

export default LegalConsent;
